/**
 * ── AP Zone Configurations ──────────────────────────────────────────
 * Coordinate bounding boxes for the 8 cities in Andhra Pradesh.
 * Used by Leaflet and Canvas for drawing overlays and markers.
 * ────────────────────────────────────────────────────────────────────────
 */

export const AP_CITY_CENTERS = {
  vijayawada: [16.5062, 80.6480],
  anantapur: [14.6819, 77.6006],
  guntur: [16.3067, 80.4365],
  visakhapatnam: [17.6868, 83.2185],
  tirupati: [13.6288, 79.4192],
  kurnool: [15.8281, 78.0373],
  nellore: [14.4426, 79.9865],
  kakinada: [16.9891, 82.2475]
};

export const ZONE_POLYGONS = {
  'VJA-GWTR': [[16.500,80.640],[16.515,80.640],[16.515,80.658],[16.500,80.658]],
  'VJA-BENZ': [[16.513,80.622],[16.528,80.622],[16.528,80.640],[16.513,80.640]],
  'VJA-MGRM': [[16.498,80.640],[16.512,80.640],[16.512,80.658],[16.498,80.658]],
  'VJA-LAND': [[16.506,80.624],[16.520,80.624],[16.520,80.638],[16.506,80.638]],
  'ATP-MAIN': [[14.674,77.592],[14.692,77.592],[14.692,77.610],[14.674,77.610]],
  'ATP-SUBR': [[14.668,77.587],[14.682,77.587],[14.682,77.600],[14.668,77.600]],
  'GNT-MAIN': [[16.298,80.428],[16.316,80.428],[16.316,80.446],[16.298,80.446]],
  'TPT-MAIN': [[13.621,79.411],[13.638,79.411],[13.638,79.429],[13.621,79.429]],
  'VSP-MVRD': [[17.730,83.305],[17.748,83.305],[17.748,83.323],[17.730,83.323]],
  'VSP-BPTN': [[17.882,83.442],[17.900,83.442],[17.900,83.460],[17.882,83.460]],
  'NLR-MAIN': [[14.435,79.978],[14.452,79.978],[14.452,79.996],[14.435,79.996]],
  'KNL-MAIN': [[15.820,78.029],[15.838,78.029],[15.838,78.047],[15.820,78.047]]
};
